import { FaSignOutAlt } from 'react-icons/fa';
import { Link, NavLink } from 'react-router';
import { useUserDetails } from '../helpers/UserContext';
import { clearToken } from '../apis/LocalStorageApi';
import { useQueryClient } from '@tanstack/react-query';

export default function Navigation() {
  const [userDetails, setUserDetails] = useUserDetails();
  const queryClient = useQueryClient();

  return (
    <div className='flex w-full flex-wrap justify-between px-2'>
      {!userDetails && (
        <div className='flex items-center justify-start '>
          <NavLink
            to='/'
            className={({ isActive, isPending }) =>
              isPending
                ? 'nav-item pending'
                : isActive
                  ? 'nav-item active'
                  : 'nav-item'
            }
          >
            Login
          </NavLink>
          <NavLink
            to='/register'
            className={({ isActive, isPending }) =>
              isPending
                ? 'nav-item pending'
                : isActive
                  ? 'nav-item active'
                  : 'nav-item'
            }
          >
            Register
          </NavLink>
        </div>
      )}
      {userDetails && (
        <div className='flex items-center justify-start '>
          <NavLink
            to='/alpacas'
            className={({ isActive, isPending }) =>
              isPending
                ? 'nav-item pending'
                : isActive
                  ? 'nav-item active'
                  : 'nav-item'
            }
          >
            Alpacas
          </NavLink>
          <NavLink
            to='/farms'
            className={({ isActive, isPending }) =>
              isPending
                ? 'nav-item pending'
                : isActive
                  ? 'nav-item active'
                  : 'nav-item'
            }
          >
            Farms
          </NavLink>
          <NavLink
            to='/contacts'
            className={({ isActive, isPending }) =>
              isPending
                ? 'nav-item pending'
                : isActive
                  ? 'nav-item active'
                  : 'nav-item'
            }
          >
            Contacts
          </NavLink>
          <NavLink
            to='/events'
            className={({ isActive, isPending }) =>
              isPending
                ? 'nav-item pending'
                : isActive
                  ? 'nav-item active'
                  : 'nav-item'
            }
          >
            Events
          </NavLink>

          <NavLink
            to='/gallery'
            className={({ isActive, isPending }) =>
              isPending
                ? 'nav-item pending'
                : isActive
                  ? 'nav-item active'
                  : 'nav-item'
            }
          >
            Gallery
          </NavLink>
          {userDetails?.email === 'blehr.mail@gmail.com' && (
            <NavLink
              to='/admin'
              className={({ isActive, isPending }) =>
                isPending
                  ? 'nav-item pending'
                  : isActive
                    ? 'nav-item active'
                    : 'nav-item'
              }
            >
              Admin
            </NavLink>
          )}
        </div>
      )}

      {userDetails && (
        <div className='flex items-center '>
          <Link to='/settings' className='nav-item'>
            {userDetails?.userName}
          </Link>
          <button
            type='button'
            className='nav-item'
            aria-label='Log out'
            value='logout'
            onClick={() => {
              clearToken();
              queryClient.clear();
              setUserDetails(null);
            }}
          >
            <FaSignOutAlt className='' />
          </button>
        </div>
      )}
    </div>
  );
}
